import React from "react";
import ContactBanner from "../../assets/image.png";

const ContactHero = () => {
  return (
    <section className="relative w-full overflow-hidden bg-black">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={ContactBanner}
          alt="Contact"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-[color:var(--navy)]/65" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/40 to-black/75" />
      </div>

      {/* Content */}
      <div className="relative z-10">
        <div
          className="
            mx-auto w-full max-w-7xl
            px-4 sm:px-6 lg:px-8
            py-16
            sm:py-20
            md:py-24
            lg:py-28
          "
        >
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-semibold text-white backdrop-blur">
              Contact
              <span className="h-1.5 w-1.5 rounded-full bg-[color:var(--brand-accent)]" />
              Let’s talk
            </div>

            <h1 className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-white">
              Talk to our team
            </h1>

            <p className="mt-5 text-base sm:text-lg text-white/85 max-w-2xl">
              Share a bit about what you’re working on. We’ll respond with a clear next step.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;
